import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from './dc-base.requester';
import { ICharacteristicType } from './models/characteristic-type.model';

@Injectable({
	providedIn: 'root',
})
export class CharacteristicTypeRequester extends DcBaseRequester<ICharacteristicType> {
	protected resource: string;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('SIMPLE_TYPES');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getAvailableTypes(): Observable<ReadonlyArray<ICharacteristicType>> {
		const url = this.urlService.generateUrl(this.resource, {}, {});
		return this.get<ReadonlyArray<ICharacteristicType>>(
			url,
			CachePolicyEntity.build({
				policy: CachePolicy.CacheOnly,
				maxAgeInSeconds: 30 * 60,
				isCacheable: true,
			})
		);
	}
}
